var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_-") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-494.000000, -2310.000000)",
    fill: "#00cfff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501,2310 C497.133885,2310 494,2313.13388 494,2317 C494,2320.86612 497.133885,2324 501,2324 C504.866115,2324 508,2320.86612 508,2317 C508,2313.13388 504.866115,2310 501,2310 Z M504.819177,2317.63679 L501.63679,2317.63679 L500.36321,2317.63679 L497.182387,2317.63679 C496.830353,2317.63679 496.545597,2317.35203 496.545597,2317 C496.545597,2316.64797 496.830353,2316.36321 497.182387,2316.36321 L500.364774,2316.36321 L501.638355,2316.36477 L504.820742,2316.36477 C505.172776,2316.36477 505.457532,2316.64953 505.457532,2317.00156 C505.455968,2317.35203 505.169647,2317.63679 504.819177,2317.63679 Z",
    id: "ic_-"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon_-.e0487b5ca09e273fc9c7946ce7a908c1.svg";
export { ForwardRef as ReactComponent };